const ITEMS = [
  "REACT 19 + EXPO NATIVE",
  "FASTAPI + NODE.JS RUNTIMES",
  "MONGODB ATLAS READY",
  "ONE-CLICK PRODUCTION URL",
  "ENTERPRISE SOC-2 CERTIFIED",
  "FULL SOURCE CODE EXPORT",
  "MODEL CONTEXT PROTOCOL READY",
];

export const Marquee = () => (
  <section className="overflow-hidden border-y border-[#e8e8e4] bg-white py-5">
    <div className="marquee-track flex w-max whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center font-mono text-xs tracking-[0.3em] text-slate-500">
          <span className="px-10">{t}</span>
          <span className="text-[#2563eb]">//</span>
        </span>
      ))}
    </div>
  </section>
);
